// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ShortUrlBindJs from "./ShortUrl.bind.js";

function make(prim) {
  return ShortUrlBindJs.make(prim);
}

function resolve(prim) {
  return ShortUrlBindJs.resolve(prim);
}

export {
  make ,
  resolve ,
  
}
/* ./ShortUrl.bind.js Not a pure module */
